import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import { patientSubscriptionPropType } from 'Shared/types';
import ClickLink from 'App/components/styles/ClickLink';
import NoSubmission from 'App/components/PatientProfile/components/PatientEngagement/MessagingStatus/NoSubmission';
import Unconfimed from 'App/components/PatientProfile/components/PatientEngagement/MessagingStatus/Unconfimed';
import Subscribed from 'App/components/PatientProfile/components/PatientEngagement/MessagingStatus/Subscribed';
import Declined from 'App/components/PatientProfile/components/PatientEngagement/MessagingStatus/Declined';
import Unsubscribed from 'App/components/PatientProfile/components/PatientEngagement/MessagingStatus/Unsubscribed';
import getCurrentState, { PatientEnrollmentStates as States } from 'App/utils/getPatientMesssageEnrollmentStatus';
import { FaMobileAlt } from 'react-icons/fa';

const propTypes = {
    subscription: patientSubscriptionPropType,
    canEnrollPatientMessaging: PropTypes.bool,
    showMessagingModal: PropTypes.func.isRequired,
    showHistoryModal: PropTypes.func.isRequired,
    showUnenrollmentModal: PropTypes.func.isRequired,
    showOneTimeModal: PropTypes.func.isRequired,
    subscribedComponent: PropTypes.elementType,
};

const defaultProps = {
    subscription: null,
    canEnrollPatientMessaging: true,
    subscribedComponent: Subscribed,
};

function MessagingStatus({
    subscription,
    canEnrollPatientMessaging,
    showMessagingModal,
    showHistoryModal,
    showUnenrollmentModal,
    showOneTimeModal,
    subscribedComponent: SubscribedComponent,
}) {
    const hasEnabledMassTexting = useIsPermitted(PERMISSION_TYPES.MASS_TEXTING);

    const state = getCurrentState(subscription);

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {R.cond([
                [
                    R.equals(States.NEVER_SUBMITTED),
                    () => {
                        return (
                            <NoSubmission
                                canEnrollPatientMessaging={canEnrollPatientMessaging}
                                showMessagingModal={showMessagingModal}
                            />
                        );
                    },
                ],
                [
                    R.equals(States.UNCONFIRMED),
                    () => {
                        return (
                            <Unconfimed showMessagingModal={showMessagingModal} showHistoryModal={showHistoryModal} />
                        );
                    },
                ],
                [
                    R.equals(States.SUBSCRIBED),
                    () => {
                        return (
                            <SubscribedComponent
                                showMessagingModal={showMessagingModal}
                                showHistoryModal={showHistoryModal}
                                showUnenrollmentModal={showUnenrollmentModal}
                            />
                        );
                    },
                ],
                [
                    R.equals(States.UNSUBSCRIBED),
                    () => {
                        return (
                            <Unsubscribed showMessagingModal={showMessagingModal} showHistoryModal={showHistoryModal} />
                        );
                    },
                ],
                [
                    R.equals(States.DECLINED),
                    () => {
                        return (
                            <Declined
                                canEnrollPatientMessaging={canEnrollPatientMessaging}
                                showMessagingModal={showMessagingModal}
                                declinedAt={subscription?.unsubscribedOn}
                            />
                        );
                    },
                ],
            ])(state)}

            {subscription?.status && hasEnabledMassTexting && (
                <ClickLink onClick={showOneTimeModal}>
                    <FaMobileAlt id="send-one-time-text-message-link" /> Send One-Time Text Message
                </ClickLink>
            )}
        </div>
    );
}

MessagingStatus.propTypes = propTypes;
MessagingStatus.defaultProps = defaultProps;

export default MessagingStatus;
